<template>
	<o-section
		:title="$t('user.profile.personalInformation')"
		:subtitle="$t('user.requiredSignatureInfo')">
		<div style="margin-top: 2rem;">
			<o-input
				:ref="setup._FirstName"
				v-model.trim="setup.firstName"
				:label="$t('common.shared.forms.firstName')"
				required
				:validation-error-message="$t('admin.validation.firstNameLettersOnly')"
				:validation="setup.validator.rule('userFirstName')"/>
			<o-input
				:ref="setup._LastName"
				v-model.trim="setup.lastName"
				:label="$t('common.forms.lastName')"
				required
				:validation-error-message="$t('admin.validation.lastNameLettersOnly')"
				:validation="setup.validator.rule('userLastName')"/>
			<o-phone
				:ref="setup._PhoneNumber"
				v-model="setup.phone"
				:label="$t('user.mobilePhoneNumber')"
				mobile
				:validation-error-message="$t('admin.validation.phoneStartsWith06Or07')"
				:validation="setup.validator.rule('phone')"/>
		</div>
	</o-section>
	<o-section align="right">
		<o-button
			outline
			color="danger"
			@click="setup.cancel()">
			{{ $t('common.label.cancel') }}
		</o-button>
		<o-button
			color="info"
			@click="setup.saveAsync()">
			{{ $t('common.label.save') }}
		</o-button>
	</o-section>
</template>

<script setup lang="ts">
import { inject } from 'vue';
const _modal = inject<OrionModal>('_modal');
// #region Setup
import type { ModalTempWorkerInfosEmits, ModalTempWorkerInfosProps } from './ModalTempWorkerInfosSetup';
import ModalTempWorkerInfosSetup from './ModalTempWorkerInfosSetup';
const emits = defineEmits<ModalTempWorkerInfosEmits>() as ModalTempWorkerInfosEmits;
const props = withDefaults(defineProps<ModalTempWorkerInfosProps>(), ModalTempWorkerInfosSetup.defaultProps);
const setup = new ModalTempWorkerInfosSetup(props, emits, _modal);
// #endregion
</script>
